import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-69">
      <div className="max-w-3xl mx-auto text-center" data-id="element-70">
        <div className="text-4xl sm:text-5xl mb-6" data-id="element-71">⚽</div>

        <h2 className="text-3xl sm:text-4xl font-serif font-black text-text-main mb-6" data-id="element-72">
          Chi è EDULABS?
        </h2>

        <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-73">
          Siamo nati con una missione: restituire tempo e pace mentale ai
          docenti di Educazione Fisica. Sappiamo quanto sia faticoso pianificare
          senza una struttura chiara. EDUFIS PRONTO è il sistema che avremmo
          voluto avere noi quando abbiamo iniziato.
        </p>
      </div>
    </section>;
}